/** @module Auth0Constants */
/* eslint-disable import/extensions */
import { getAllTenantClasses } from '../config/auth0-tenant-registry.mjs';

const AUTH0_SPAJS_VERSION = '2.1';
const AUTH0_FORCE_LOGOUT = 'ss.force.logout';
const AUTH0_UNLINK_ALL = 'ss.unlink.all';
const AUTH0_CHANNEL_REFRESH = 'ss.auth.channel.refresh';
const AUTH0_IDP_REDIRECT_LOGIN = 'ss.idp.login.with.redirect';
const SECONDARY_TOKENS_KEY = 'ss.secondary.idp.tokens';
const AUTH0_IDP_CONTEXT_KEY = 'ss.idp.context';
const AUTH0_IDP_SIGNIN_CONTEXT_KEY = 'signin';
const AUTH0_IDP_SIGNIN_CONTEXT_VAL_LOGIN_PAGE = 'loginPage';
const AUTH0_IDP_SIGNIN_CONTEXT_VAL_MARKETING_PAGE = 'marketingPage';
const AUTH0_IDP_SIGNIN_CONTEXT_VAL_USER_PROFILE_PAGE = 'v3UserProfilePage';
const AUTH0_SOURCE_CONTEXT_KEY = 'ss.source.context';
const AUTH0_IDP_INITIATED_KEY = 'ss.idp.initiated';
const AUTH0_NEEDS_NEW_USER_ACTIONS = 'ss.new.auth0.user';
const AUTH0_NEW_USER_TRACKING_DATA = 'ss.new.user.data';
const AUTH0_RESTRICTED_ACCOUNT_LINK_KEY = 'ss.restricted.account.link';
const AUTH0_BETA_OPT_IN_KEY = 'ss.opt.in';
const APP_LOGIN_URL_KEY = 'app_login_url';
const SHOPIFY_SHOP_NAME_KEY = 'ss.shopify.host';
const SHOPIFY_SHOP_NAME_IN_PROGRESS_KEY = 'ss.shopify.host.in.progress';
const AUTH0_IS_NATIVE_SSO_SELLER = 'ss.native.sso.seller';
const AUTH0_LINKING_REQUEST_STATE = 'ss.linking.request';
const AUTH0_LINKING_TOKEN_KEY = 'linkingToken';
const AUTH0_LINKING_IN_PROGRESS = 'ss.linking.in.progress';
// SessionStorage keys for redirect-based SSO linking flow
// These store the SSO user's credentials during the redirect to SS login
const AUTH0_LINKING_CACHED_SSO_JWT = 'ss.linking.cached.sso.jwt';
const AUTH0_LINKING_CACHED_SSO_ID_TOKEN = 'ss.linking.cached.sso.id.token';
const AUTH0_LINKING_CACHED_SSO_USER_ID = 'ss.linking.cached.sso.user.id';
const AUTH0_LINKING_CACHED_METADATA = 'ss.linking.cached.metadata';
const AUTH0_ADDITIONAL_APP_STATE = 'additionalState';
const AUTH0_SPAJS_SESSION_STATE = 'auth0spajs.session.state';

const AUTH0_DEV_LOCAL_MULTI_PARTITION_TESTING_KEY = '-other-partition';

const AUTH0_REMEMBER_ME_DEVICE_ID_KEY = 'ss_rem_dev';
const AUTH0_CLIENT_REMEMBER_ME_DEVICE_ID_OVERRIDE_KEY = 'deviceId';
const AUTH0_REMEMBER_ME_NUM_DAYS = 400;

const AUTH0_ONBOARD_REQUEST_DATA_KEY = 'userOnboardRequest';

const AUTH0_EXTERNAL_APP_LOGIN_KEY = 'ss.external.app';
const AUTH0_LEGACY_EXTERNAL_LOGIN_KEY = 'external-callback';
const EXTERNAL_APP_ID_SHIPSTATION_CONNECT = 'ss-connect';

const AUTH0_ID_PREFIX = 'auth0|';
const AUTH0_CLAIM_NAMESPACE = 'http://shipstation.com/';
const AUTH0_IS_AUTHENTICATED = 'auth0.is.authenticated';
const AUTH_COOKIE = 'auth';
const AUTH0_IS_LOGIN_PROVIDER = 'auth0.is.login';
const AUTH0_IS_AUTHENTICATED_CLIENT_KEY = '{clientId}';
const AUTH0_IS_AUTHENTICATED_CLIENT = `auth0.${AUTH0_IS_AUTHENTICATED_CLIENT_KEY}.is.authenticated`;
const AUTH0_IS_AUTHENTICATED_CLIENT_LEGACY = `_legacy_auth0.${AUTH0_IS_AUTHENTICATED_CLIENT_KEY}.is.authenticated`;
const AUTH0_LOCALSTORAGE_COOKIE_NAME_AT = 'ss.auth0.localstorage.at';
const AUTH0_LOCALSTORAGE_COOKIE_NAME_IDT = 'ss.auth0.localstorage.idt';

const ERROR_MESSAGE = 'auth0.error.msg';
const AUTH0_IS_IN_ERROR_STATE = 'auth0.is.error';
const AUTH0_IS_IN_ERROR_STATE_QS = 'error';
const AUTH0_ERROR_STATE_CODE_ACCESS_DENIED = 'access_denied';
const ERROR_CODE_FAIL_NON_200 = 100;
const ERROR_CODE_FAIL_XHR_ERROR = 101;
const ERROR_CODE_FAIL_UNLINKED_FAILED_DELETE = 104;
const ERROR_CODE_NO_MGMT_TOKEN = 102;
const ERROR_CODE_MGMT_TOKEN_FAIL = 103;
const ERROR_CODE_CREATE_USER_ALREADY_EXISTS = 409;
const ERROR_CODE_CREATE_USER_UNKNOWN = 500;
const ERROR_CODE_CREATE_USER_TIMEOUT = 408;
const ERROR_CODE_CREATE_USER_CAPTCHA_FAIL = 417;
const ERROR_CODE_CREATE_USER_FRAUD = 423;
const ERROR_CODE_CREATE_USER_BAD_REQUEST = 502;
const ERROR_CODE_CREATE_USER_EMAIL_TOO_LONG = 503;
const ERROR_CODE_CREATE_USER_PARTIAL_SUCCESS = 207;

const INFO_MESSAGE = 'auth0.info.msg';
const LOGOUT_MESSAGE = 'ss.logout.msg';

const GLOBAL_FLOW_TIMEOUT_SEC = 300;

const PD_VARIANT_FOR_NEW_FORM_USER = 1;
const PD_VARIANT_FOR_NEW_SSO_USER = 2;

const LOGOUT_TYPE_REDIRECT = 0;
const LOGOUT_TYPE_NO_REDIRECT = 1;
const LOGOUT_TYPE_FEDERATED_REDIRECT = 2;
const LOGOUT_TYPE_FEDERATED_NO_REDIRECT = 3;

const USER_ONBOARDING_CHANNEL_FORM = 'form';
const USER_ONBOARDING_CHANNEL_SSO = 'SSO';

const AUTH0_ACCESS_TOKEN_V3_KEY = '_latv3';
const AUTH0_ACCESS_TOKEN_V2_KEY = '_lat';

const IDS_NAME_PROD = 'idapi';
const IDS_NAME_STAGE = 'idapi-stage';
const IDS_NAME_DEV = 'idapi-dev';
const IDS_NAME_LOCAL = 'idapi-local';
const IDS_NAME_LOCAL_Z = 'idapi-local-z';
const IDS_NAME_LOCAL_Z2 = 'idapi-local-z2';
const IDS_NAME_LOCAL_Z3 = 'idapi-local-z3';

const AUTH0_APP_ID_SSV3 = 'app:ssv3';
const AUTH0_APP_ID_SS_LITE = 'app:ss-lite';
const AUTH0_APP_ID_SS_BACKEND = 'app:ss:be';
const AUTH0_APP_ID_SSV2 = 'app:ssv2';
const AUTH0_APP_ID_SE = 'app:se';
const AUTH0_APP_ID_SS_API_DASH = 'app:ss-api-dash';
const AUTH0_APP_ID_IOS = 'app:ss-ios';
const AUTH0_APP_ID_IOS_WEBVIEW = 'app:ss-ios:wv';
const AUTH0_APP_ID_ANDROID = 'app:ss-android';
const AUTH0_APP_ID_ANDROID_WEBVIEW = 'app:ss-android:wv';
const AUTH0_APP_ID_M2M = 'app:m2m';
const AUTH0_APP_ID_PARTNERS_WEBAPP = 'app:partners-webapp';

// DO NOT REMOVE; MUSTACHE VAR OVERRIDE; 
const USER_ONBOARDING_PASSWORD_PREFIX = 'sso-user-7893ab52-54eb-4e18-8d74-5cedf301178d|';

// don't fail the unit test just because we define the token here (url encode it here)
const DO_NOT_MERGE_TOKEN = 'DO%20NOT%20MERGE%20THIS%20CHANGE!!!!!!!!!!!!';

const AUTH_LOCALE_KEY = 'ss.auth.locale';
const AUTH_LOCALE_REPLACEMENT_ARGS_KEY = 'localize-args';
const AUTH_LOCALE_RESOURCE_ID_KEY = 'resource-id';
const AUTH_LOCALE_TRANSLATABLE_KEY = 'translatable-element';

const AUTH0_DEFAULT_AUDIENCE = 'ss:webapi';
const AUTH0_DEVICES_SERVICE_AUDIENCE = 'ss:devicesservice';

const AUTH_ERROR_DISPLAY_ON_KEY = 'display_on';
const AUTH_ERROR_DISPLAY_ON_LOGIN_PAGE_VAL = 'lp';
const AUTH_ERROR_DISPLAY_ON_NOTIFICATION_PAGE_VAL = 'np';
const AUTH_ERROR_KEY1 = 'error';
const AUTH_ERROR_KEY2 = 'error_description';
const AUTH_INFO_MESSAGE = 'info_msg';
const AUTH0_ERROR_FRAGMENT_WEBTASK_TIMEOUT = 'Webtask exceeded allowed execution time';
const AUTH0_ERROR_FRAGMENT_WEBTASK_CAPTCHA_FAIL = 'Invalid Request (GCF';
const AUTH0_ERROR_FRAGMENT_WEBTASK_FRAUD = 'BlackBox has flagged user';

const HIDE_PASSWORD_ICON = 'eye.svg';
const SHOW_PASSWORD_ICON = 'eye-slash.svg';
const PASSWORD_VALID_ICON = 'circle-check-green.svg';
const PASSWORD_INVALID_ICON = 'circle-check-grey.svg';
const GENERIC_OK_ICON = 'circle-check-green.svg';
const GENERIC_ERROR_ICON = 'error.svg';

const PASSWORD_POLICY_KEY = 'ss.password.policy';
const CHANGE_PASSWORD_DISPLAY_MODE_INVOKE = 'invoke';
const CHANGE_PASSWORD_DISPLAY_MODE_AUTO_INVOKE = 'auto-invoke';
const CHANGE_PASSWORD_DISPLAY_MODE_CHANGE = 'change';


const FAKE_USERNAME_EMAIL_LOCAL_PART = 'anyuser__api__validation';
const ILLEGAL_EMAIL_ADDRESS_CHAR_MAPPING = {
  '+': 'pssDpssDpss',
  '/': 'fssDfssDfss',
  '=': 'eqsDeqsDeqs',
};

const PHONE = 'phone';
const EMAIL = 'email';
const RECOVERY_CODE = 'recovery-code';
const TOTP = 'totp';

const MFA_TYPE_OOB = 'oob';
const MFA_TYPE_OTP = 'otp';
const MFA_TYPE_RECOVERY_CODE = RECOVERY_CODE;
const MFA_OOB_CHANNEL_EMAIL = EMAIL;
const MFA_OOB_CHANNEL_SMS = 'sms';
const MFA_OOB_CHANNEL_VOICE = 'voice';
const MFA_ENROLLMENT_TYPES = {
  PHONE,
  EMAIL,
  RECOVERY_CODE,
  TOTP,
};

const MFA_OOB_CHANNEL_AUTH0 = 'auth0';
const MFA_ERROR_CODE_AMFA_FACTOR_NOT_FOUND = 'email_mfa_not_found';
const MFA_OOB_TYPES = [MFA_OOB_CHANNEL_EMAIL, MFA_OOB_CHANNEL_SMS, MFA_OOB_CHANNEL_VOICE, MFA_OOB_CHANNEL_AUTH0];
const MFA_ERROR_CODE_INIT_MFA_TOKEN_FETCH_FAIL = 1000;
const MFA_ERROR_CODE_INIT_MFA_TOKEN_FETCH_FAIL_USER_MISSING = 1001;
const MFA_ERROR_CODE_INIT_EMAIL_FACTOR_ID_FAIL = 1010;
const MFA_ERROR_CODE_INIT_ENROLL_IN_EMAIL_FAIL = 1020;
const MFA_ERROR_CODE_INIT_EMAIL_CHALLENGE_FAIL = 1030;
const MFA_ERROR_CODE_INIT_INTERMEDIATE_JWT_INVALID = 1040;
const MFA_ERROR_CODE_ENROLL_FAIL = 2000;
const MFA_ERROR_CODE_ENROLL_OOB_CODE_MISSING = 2010;
const MFA_ERROR_CODE_ENROLL_MISSING_TOKENS = 2020;
const MFA_ERROR_CODE_ENROLL_INVALID_GRANT_TOKEN = 2030;
const MFA_ERROR_CODE_ENROLL_EMAIL_MISMATCH = 2040;
const MFA_ERROR_CODE_ENROLL_FACTOR_ALREADY_ENROLLED = 2050;
const MFA_ERROR_CODE_CHALLENGE_OOB_CODE_MISSING = 3000;
const MFA_ERROR_CODE_CHALLENGE_NO_VALID_FACTORS = 3010;
const MFA_ERROR_CODE_CHALLENGE_FACTOR_SELECTION_ERROR = 3020;
const MFA_ERROR_CODE_CHALLENGE_FACTOR_KNOWN_EMAIL_ERROR = 3030;
const MFA_ERROR_CODE_VERIFY_WITHOUT_CHALLENGE = 4000;
const MFA_ERROR_CODE_VERIFY_FAILED = 4010;
const MFA_ERROR_CODE_FETCH_ENROLLMENTS_FAIL = 5000;
const MFA_ERROR_CODE_UNENROLL_FAIL = 6000;
const MFA_ERROR_CODE_OPT_OUT_FAIL = 6050;

const AUTH0_CREATE_USER_ALLOWED_PROPS = [
  'app_metadata', 'blocked', 'connection', 'email', 'email_verified', 'family_name', 'given_name', 'name', 'nickname',
  'password', 'phone_number', 'phone_verified', 'picture', 'user_id', 'user_metadata', 'username', 'verify_email',
];

// these are the cookies that hold auth state and also what will be cleared when the auth flow needs to reset
const AUTH0_STATE_COOKIES = [
  AUTH0_UNLINK_ALL,
  AUTH0_CHANNEL_REFRESH,
  AUTH0_IDP_REDIRECT_LOGIN,
  SECONDARY_TOKENS_KEY,
  AUTH0_IDP_CONTEXT_KEY,
  AUTH0_SOURCE_CONTEXT_KEY,
  AUTH0_NEEDS_NEW_USER_ACTIONS,
  AUTH0_NEW_USER_TRACKING_DATA,
  SHOPIFY_SHOP_NAME_KEY,
  SHOPIFY_SHOP_NAME_IN_PROGRESS_KEY,
  AUTH0_IS_LOGIN_PROVIDER,
  AUTH0_IS_AUTHENTICATED,
  AUTH0_IS_AUTHENTICATED_CLIENT,
  AUTH0_LOCALSTORAGE_COOKIE_NAME_AT,
  AUTH0_LOCALSTORAGE_COOKIE_NAME_IDT,
  AUTH0_RESTRICTED_ACCOUNT_LINK_KEY,
  AUTH0_IS_NATIVE_SSO_SELLER,
  AUTH0_LEGACY_EXTERNAL_LOGIN_KEY,
];

const AUTH0_MESSAGING_STATE_COOKIES = [
  ERROR_MESSAGE,
  INFO_MESSAGE,
  LOGOUT_MESSAGE,
];

class Auth0Constants {
  static get AUTH0_SPAJS_VERSION() {
    return AUTH0_SPAJS_VERSION;
  }

  static get AUTH0_SPAJS_URL() {
    return `https://cdn.auth0.com/js/auth0-spa-js/${Auth0Constants.AUTH0_SPAJS_VERSION}/auth0-spa-js.production.js`;
  }

  static get AUTH0_ACTIVE_TENANT_CLASSES() {
    return getAllTenantClasses();
  }

  static get AUTH0_EXTERNAL_APP_LOGIN_KEY() {
    return AUTH0_EXTERNAL_APP_LOGIN_KEY;
  }

  static get AUTH0_LEGACY_EXTERNAL_LOGIN_KEY() {
    return AUTH0_LEGACY_EXTERNAL_LOGIN_KEY;
  }

  static get LOGOUT_TYPE_REDIRECT() {
    return LOGOUT_TYPE_REDIRECT;
  }

  static get LOGOUT_TYPE_NO_REDIRECT() {
    return LOGOUT_TYPE_NO_REDIRECT;
  }

  static get LOGOUT_TYPE_FEDERATED_REDIRECT() {
    return LOGOUT_TYPE_FEDERATED_REDIRECT;
  }

  static get LOGOUT_TYPE_FEDERATED_NO_REDIRECT() {
    return LOGOUT_TYPE_FEDERATED_NO_REDIRECT;
  }

  static get AUTH0_IS_LOGIN_PROVIDER() {
    return AUTH0_IS_LOGIN_PROVIDER;
  }

  static get AUTH0_LINKING_REQUEST_STATE() {
    return AUTH0_LINKING_REQUEST_STATE;
  }

  static get AUTH0_LINKING_TOKEN_KEY() {
    return AUTH0_LINKING_TOKEN_KEY;
  }

  static get AUTH0_LINKING_IN_PROGRESS() {
    return AUTH0_LINKING_IN_PROGRESS;
  }

  static get AUTH0_IS_NATIVE_SSO_SELLER() {
    return AUTH0_IS_NATIVE_SSO_SELLER;
  }

  static get AUTH0_DEFAULT_AUDIENCE() {
    return AUTH0_DEFAULT_AUDIENCE;
  }

  static get AUTH0_DEVICES_SERVICE_AUDIENCE() {
    return AUTH0_DEVICES_SERVICE_AUDIENCE;
  }

  static get AUTH0_IS_IN_ERROR_STATE() {
    return AUTH0_IS_IN_ERROR_STATE;
  }

  static get AUTH0_IS_IN_ERROR_STATE_QS() {
    return AUTH0_IS_IN_ERROR_STATE_QS;
  }

  static get AUTH0_ERROR_STATE_CODE_ACCESS_DENIED() {
    return AUTH0_ERROR_STATE_CODE_ACCESS_DENIED;
  }

  static get AUTH0_FORCE_LOGOUT() {
    return AUTH0_FORCE_LOGOUT;
  }

  static get AUTH0_STATE_COOKIES() {
    return AUTH0_STATE_COOKIES;
  }

  static get AUTH0_MESSAGING_STATE_COOKIES() {
    return AUTH0_MESSAGING_STATE_COOKIES;
  }

  static get AUTH0_ALL_STATE_COOKIES() {
    return [
      ...AUTH0_STATE_COOKIES,
      ...AUTH0_MESSAGING_STATE_COOKIES,
    ];
  }

  static get AUTH0_UNLINK_ALL() {
    return AUTH0_UNLINK_ALL;
  }

  static get AUTH0_ADDITIONAL_APP_STATE() {
    return AUTH0_ADDITIONAL_APP_STATE;
  }

  static get AUTH0_SPAJS_SESSION_STATE() {
    return AUTH0_SPAJS_SESSION_STATE;
  }

  static get AUTH0_ONBOARD_REQUEST_DATA_KEY() {
    return AUTH0_ONBOARD_REQUEST_DATA_KEY;
  }

  static get AUTH0_NEW_USER_TRACKING_DATA() {
    return AUTH0_NEW_USER_TRACKING_DATA;
  }

  static get AUTH0_ID_PREFIX() {
    return AUTH0_ID_PREFIX;
  }

  static get AUTH0_CLAIM_NAMESPACE() {
    return AUTH0_CLAIM_NAMESPACE;
  }

  static get AUTH0_CHANNEL_REFRESH() {
    return AUTH0_CHANNEL_REFRESH;
  }

  static get AUTH0_IDP_REDIRECT_LOGIN() {
    return AUTH0_IDP_REDIRECT_LOGIN;
  }

  static get SECONDARY_TOKENS_KEY() {
    return SECONDARY_TOKENS_KEY;
  }

  static get APP_LOGIN_URL_KEY() {
    return APP_LOGIN_URL_KEY;
  }

  static get AUTH0_IDP_CONTEXT_KEY() {
    return AUTH0_IDP_CONTEXT_KEY;
  }

  static get AUTH0_IDP_SIGNIN_CONTEXT_KEY() {
    return AUTH0_IDP_SIGNIN_CONTEXT_KEY;
  }

  static get AUTH0_IDP_SIGNIN_CONTEXT_VAL_LOGIN_PAGE() {
    return AUTH0_IDP_SIGNIN_CONTEXT_VAL_LOGIN_PAGE;
  }

  static get AUTH0_IDP_SIGNIN_CONTEXT_VAL_MARKETING_PAGE() {
    return AUTH0_IDP_SIGNIN_CONTEXT_VAL_MARKETING_PAGE;
  }

  static get AUTH0_IDP_SIGNIN_CONTEXT_VAL_V3_USER_PROFILE_PAGE() {
    return AUTH0_IDP_SIGNIN_CONTEXT_VAL_USER_PROFILE_PAGE;
  }

  static get AUTH0_SOURCE_CONTEXT_KEY() {
    return AUTH0_SOURCE_CONTEXT_KEY;
  }

  static get AUTH0_IDP_INITIATED_KEY() {
    return AUTH0_IDP_INITIATED_KEY;
  }

  static get AUTH0_LOCALSTORAGE_COOKIE_NAME_AT() {
    return AUTH0_LOCALSTORAGE_COOKIE_NAME_AT;
  }

  static get AUTH0_LOCALSTORAGE_COOKIE_NAME_IDT() {
    return AUTH0_LOCALSTORAGE_COOKIE_NAME_IDT;
  }

  static get AUTH0_BETA_OPT_IN_KEY() {
    return AUTH0_BETA_OPT_IN_KEY;
  }

  static get SHOPIFY_SHOP_HOST_NAME_KEY() {
    return SHOPIFY_SHOP_NAME_KEY;
  }

  static get SHOPIFY_SHOP_NAME_IN_PROGRESS_KEY() {
    return SHOPIFY_SHOP_NAME_IN_PROGRESS_KEY;
  }

  static get ERROR_CODE_FAIL_NON_200() {
    return ERROR_CODE_FAIL_NON_200;
  }

  static get ERROR_CODE_FAIL_XHR_ERROR() {
    return ERROR_CODE_FAIL_XHR_ERROR;
  }

  static get ERROR_CODE_NO_MGMT_TOKEN() {
    return ERROR_CODE_NO_MGMT_TOKEN;
  }

  static get ERROR_CODE_MGMT_TOKEN_FAIL() {
    return ERROR_CODE_MGMT_TOKEN_FAIL;
  }

  static get ERROR_CODE_FAIL_UNLINKED_FAILED_DELETE() {
    return ERROR_CODE_FAIL_UNLINKED_FAILED_DELETE;
  }

  static get ERROR_CODE_CREATE_USER_ALREADY_EXISTS() {
    return ERROR_CODE_CREATE_USER_ALREADY_EXISTS;
  }

  static get ERROR_CODE_CREATE_USER_UNKNOWN() {
    return ERROR_CODE_CREATE_USER_UNKNOWN;
  }

  static get ERROR_CODE_CREATE_USER_TIMEOUT() {
    return ERROR_CODE_CREATE_USER_TIMEOUT;
  }

  static get ERROR_CODE_CREATE_USER_CAPTCHA_FAIL() {
    return ERROR_CODE_CREATE_USER_CAPTCHA_FAIL;
  }

  static get ERROR_CODE_CREATE_USER_FRAUD() {
    return ERROR_CODE_CREATE_USER_FRAUD;
  }

  static get ERROR_CODE_CREATE_USER_BAD_REQUEST() {
    return ERROR_CODE_CREATE_USER_BAD_REQUEST;
  }

  static get ERROR_CODE_CREATE_USER_EMAIL_TOO_LONG() {
    return ERROR_CODE_CREATE_USER_EMAIL_TOO_LONG;
  }

  static get ERROR_CODE_CREATE_USER_PARTIAL_SUCCESS() {
    return ERROR_CODE_CREATE_USER_PARTIAL_SUCCESS;
  }

  static get ERROR_MESSAGE() {
    return ERROR_MESSAGE;
  }

  static get INFO_MESSAGE() {
    return INFO_MESSAGE;
  }

  static get LOGOUT_MESSAGE() {
    return LOGOUT_MESSAGE;
  }

  static get AUTH0_IS_AUTHENTICATED() {
    return AUTH0_IS_AUTHENTICATED;
  }

  static get AUTH0_IS_AUTHENTICATED_PATTERN() {
    return AUTH0_IS_AUTHENTICATED_CLIENT;
  }

  static AUTH0_IS_AUTHENTICATED_CLIENT(clientId) {
    return AUTH0_IS_AUTHENTICATED_CLIENT.replace(AUTH0_IS_AUTHENTICATED_CLIENT_KEY, clientId);
  }

  static AUTH0_IS_AUTHENTICATED_LEGACY_CLIENT(clientId) {
    return AUTH0_IS_AUTHENTICATED_CLIENT_LEGACY.replace(AUTH0_IS_AUTHENTICATED_CLIENT_KEY, clientId);
  }

  static get GLOBAL_FLOW_TIMEOUT_SEC() {
    return GLOBAL_FLOW_TIMEOUT_SEC;
  }

  static get PD_VARIANT_FOR_NEW_SSO_USER() {
    return PD_VARIANT_FOR_NEW_SSO_USER;
  }

  static get PD_VARIANT_FOR_NEW_FORM_USER() {
    return PD_VARIANT_FOR_NEW_FORM_USER;
  }

  static get USER_ONBOARDING_CHANNEL_FORM() {
    return USER_ONBOARDING_CHANNEL_FORM;
  }

  static get USER_ONBOARDING_CHANNEL_SSO() {
    return USER_ONBOARDING_CHANNEL_SSO;
  }

  static get USER_ONBOARDING_PASSWORD_PREFIX() {
    return USER_ONBOARDING_PASSWORD_PREFIX;
  }

  static get AUTH0_CREATE_USER_ALLOWED_PROPS() {
    return AUTH0_CREATE_USER_ALLOWED_PROPS;
  }

  static get AUTH_LOCALE_KEY() {
    return AUTH_LOCALE_KEY;
  }

  static get AUTH_LOCALE_RESOURCE_ID_KEY() {
    return AUTH_LOCALE_RESOURCE_ID_KEY;
  }

  static get AUTH_LOCALE_REPLACEMENT_ARGS_KEY() {
    return AUTH_LOCALE_REPLACEMENT_ARGS_KEY;
  }

  static get AUTH_LOCALE_TRANSLATABLE_KEY() {
    return AUTH_LOCALE_TRANSLATABLE_KEY;
  }

  static get AUTH0_NEEDS_NEW_USER_ACTIONS() {
    return AUTH0_NEEDS_NEW_USER_ACTIONS;
  }

  static get AUTH0_RESTRICTED_ACCOUNT_LINK_KEY() {
    return AUTH0_RESTRICTED_ACCOUNT_LINK_KEY;
  }

  static get AUTH0_ACCESS_TOKEN_V3_KEY() {
    return AUTH0_ACCESS_TOKEN_V3_KEY;
  }

  static get AUTH0_ACCESS_TOKEN_V2_KEY() {
    return AUTH0_ACCESS_TOKEN_V2_KEY;
  }

  static get AUTH_ERROR_DISPLAY_ON_KEY() {
    return AUTH_ERROR_DISPLAY_ON_KEY;
  }

  static get AUTH_ERROR_DISPLAY_ON_LOGIN_PAGE_VAL() {
    return AUTH_ERROR_DISPLAY_ON_LOGIN_PAGE_VAL;
  }

  static get AUTH_ERROR_DISPLAY_ON_NOTIFICATION_PAGE_VAL() {
    return AUTH_ERROR_DISPLAY_ON_NOTIFICATION_PAGE_VAL;
  }

  static get AUTH_ERROR_KEY1() {
    return AUTH_ERROR_KEY1;
  }

  static get AUTH_ERROR_KEY2() {
    return AUTH_ERROR_KEY2;
  }

  static get AUTH_INFO_MESSAGE() {
    return AUTH_INFO_MESSAGE;
  }

  static get AUTH0_ERROR_FRAGMENT_WEBTASK_TIMEOUT() {
    return AUTH0_ERROR_FRAGMENT_WEBTASK_TIMEOUT;
  }

  static get AUTH0_ERROR_FRAGMENT_WEBTASK_CAPTCHA_FAIL() {
    return AUTH0_ERROR_FRAGMENT_WEBTASK_CAPTCHA_FAIL;
  }

  static get AUTH0_ERROR_FRAGMENT_WEBTASK_FRAUD() {
    return AUTH0_ERROR_FRAGMENT_WEBTASK_FRAUD;
  }

  static get DO_NOT_MERGE_TOKEN() {
    return decodeURIComponent(DO_NOT_MERGE_TOKEN);
  }

  static get HIDE_PASSWORD_ICON() {
    return HIDE_PASSWORD_ICON;
  }

  static get SHOW_PASSWORD_ICON() {
    return SHOW_PASSWORD_ICON;
  }

  static get PASSWORD_VALID_ICON() {
    return PASSWORD_VALID_ICON;
  }

  static get PASSWORD_INVALID_ICON() {
    return PASSWORD_INVALID_ICON;
  }

  static get GENERIC_OK_ICON() {
    return GENERIC_OK_ICON;
  }

  static get GENERIC_ERROR_ICON() {
    return GENERIC_ERROR_ICON;
  }

  static get CHANGE_PASSWORD_DISPLAY_MODE_INVOKE() {
    return CHANGE_PASSWORD_DISPLAY_MODE_INVOKE;
  }

  static get CHANGE_PASSWORD_DISPLAY_MODE_AUTO_INVOKE() {
    return CHANGE_PASSWORD_DISPLAY_MODE_AUTO_INVOKE;
  }

  static get CHANGE_PASSWORD_DISPLAY_MODE_CHANGE() {
    return CHANGE_PASSWORD_DISPLAY_MODE_CHANGE;
  }

  static get PASSWORD_POLICY_KEY() {
    return PASSWORD_POLICY_KEY;
  }

  static get MFA_ERROR_CODE_INIT_MFA_TOKEN_FETCH_FAIL() {
    return MFA_ERROR_CODE_INIT_MFA_TOKEN_FETCH_FAIL;
  }

  static get MFA_ERROR_CODE_INIT_MFA_TOKEN_FETCH_FAIL_USER_MISSING() {
    return MFA_ERROR_CODE_INIT_MFA_TOKEN_FETCH_FAIL_USER_MISSING;
  }

  static get MFA_ERROR_CODE_INIT_EMAIL_FACTOR_ID_FAIL() {
    return MFA_ERROR_CODE_INIT_EMAIL_FACTOR_ID_FAIL;
  }

  static get MFA_ERROR_CODE_INIT_ENROLL_IN_EMAIL_FAIL() {
    return MFA_ERROR_CODE_INIT_ENROLL_IN_EMAIL_FAIL;
  }

  static get MFA_ERROR_CODE_INIT_EMAIL_CHALLENGE_FAIL() {
    return MFA_ERROR_CODE_INIT_EMAIL_CHALLENGE_FAIL;
  }

  static get MFA_ERROR_CODE_ENROLL_FAIL() {
    return MFA_ERROR_CODE_ENROLL_FAIL;
  }

  static get MFA_ERROR_CODE_ENROLL_OOB_CODE_MISSING() {
    return MFA_ERROR_CODE_ENROLL_OOB_CODE_MISSING;
  }

  static get MFA_ERROR_CODE_ENROLL_MISSING_TOKENS() {
    return MFA_ERROR_CODE_ENROLL_MISSING_TOKENS;
  }

  static get MFA_ERROR_CODE_ENROLL_INVALID_GRANT_TOKEN() {
    return MFA_ERROR_CODE_ENROLL_INVALID_GRANT_TOKEN;
  }

  static get MFA_ERROR_CODE_ENROLL_EMAIL_MISMATCH() {
    return MFA_ERROR_CODE_ENROLL_EMAIL_MISMATCH;
  }

  static get MFA_ERROR_CODE_ENROLL_FACTOR_ALREADY_ENROLLED() {
    return MFA_ERROR_CODE_ENROLL_FACTOR_ALREADY_ENROLLED;
  }

  static get MFA_ERROR_CODE_CHALLENGE_OOB_CODE_MISSING() {
    return MFA_ERROR_CODE_CHALLENGE_OOB_CODE_MISSING;
  }

  static get MFA_ERROR_CODE_INIT_INTERMEDIATE_JWT_INVALID() {
    return MFA_ERROR_CODE_INIT_INTERMEDIATE_JWT_INVALID;
  }

  static get MFA_ERROR_CODE_VERIFY_WITHOUT_CHALLENGE() {
    return MFA_ERROR_CODE_VERIFY_WITHOUT_CHALLENGE;
  }

  static get MFA_ERROR_CODE_CHALLENGE_NO_VALID_FACTORS() {
    return MFA_ERROR_CODE_CHALLENGE_NO_VALID_FACTORS;
  }

  static get MFA_ERROR_CODE_CHALLENGE_FACTOR_SELECTION_ERROR() {
    return MFA_ERROR_CODE_CHALLENGE_FACTOR_SELECTION_ERROR;
  }

  static get MFA_ERROR_CODE_CHALLENGE_FACTOR_KNOWN_EMAIL_ERROR() {
    return MFA_ERROR_CODE_CHALLENGE_FACTOR_KNOWN_EMAIL_ERROR;
  }

  static get MFA_ERROR_CODE_VERIFY_FAILED() {
    return MFA_ERROR_CODE_VERIFY_FAILED;
  }

  static get MFA_ERROR_CODE_FETCH_ENROLLMENTS_FAIL() {
    return MFA_ERROR_CODE_FETCH_ENROLLMENTS_FAIL;
  }

  static get MFA_ERROR_CODE_UNENROLL_FAIL() {
    return MFA_ERROR_CODE_UNENROLL_FAIL;
  }

  static get MFA_ERROR_CODE_OPT_OUT_FAIL() {
    return MFA_ERROR_CODE_OPT_OUT_FAIL;
  }

  static get MFA_ERROR_CODE_AMFA_FACTOR_NOT_FOUND() {
    return MFA_ERROR_CODE_AMFA_FACTOR_NOT_FOUND;
  }

  static get MFA_TYPE_OOB() {
    return MFA_TYPE_OOB;
  }

  static get MFA_TYPE_OTP() {
    return MFA_TYPE_OTP;
  }

  static get MFA_TYPE_TOTP() {
    return TOTP;
  }

  static get MFA_TYPE_RECOVERY_CODE() {
    return MFA_TYPE_RECOVERY_CODE;
  }

  static get MFA_OOB_CHANNEL_EMAIL() {
    return MFA_OOB_CHANNEL_EMAIL;
  }

  static get MFA_OOB_CHANNEL_SMS() {
    return MFA_OOB_CHANNEL_SMS;
  }

  static get MFA_OOB_CHANNEL_VOICE() {
    return MFA_OOB_CHANNEL_VOICE;
  }

  static get MFA_OOB_CHANNEL_AUTH0() {
    return MFA_OOB_CHANNEL_AUTH0;
  }

  static get MFA_OOB_TYPES() {
    return MFA_OOB_TYPES;
  }

  static get MFA_ENROLLMENT_TYPES() {
    return MFA_ENROLLMENT_TYPES;
  }

  static get IDS_NAME_PROD() {
    return IDS_NAME_PROD;
  }

  static get IDS_NAME_STAGE() {
    return IDS_NAME_STAGE;
  }

  static get IDS_NAME_DEV() {
    return IDS_NAME_DEV;
  }

  static get IDS_NAME_LOCAL() {
    return IDS_NAME_LOCAL;
  }

  static get IDS_NAME_LOCAL_Z() {
    return IDS_NAME_LOCAL_Z;
  }

  static get IDS_NAME_LOCAL_Z2() {
    return IDS_NAME_LOCAL_Z2;
  }

  static get IDS_NAME_LOCAL_Z3() {
    return IDS_NAME_LOCAL_Z3;
  }

  static get AUTH0_APP_ID_SSV3() {
    return AUTH0_APP_ID_SSV3;
  }

  static get AUTH0_APP_ID_SS_LITE() {
    return AUTH0_APP_ID_SS_LITE;
  }

  static get AUTH0_APP_ID_SS_BACKEND() {
    return AUTH0_APP_ID_SS_BACKEND;
  }

  static get AUTH0_APP_ID_SSV2() {
    return AUTH0_APP_ID_SSV2;
  }

  static get AUTH0_APP_ID_SE() {
    return AUTH0_APP_ID_SE;
  }

  static get AUTH0_APP_ID_SS_API_DASH() {
    return AUTH0_APP_ID_SS_API_DASH;
  }

  static get AUTH0_APP_ID_IOS() {
    return AUTH0_APP_ID_IOS;
  }

  static get AUTH0_APP_ID_IOS_WEBVIEW() {
    return AUTH0_APP_ID_IOS_WEBVIEW;
  }

  static get AUTH0_APP_ID_ANDROID() {
    return AUTH0_APP_ID_ANDROID;
  }

  static get AUTH0_APP_ID_ANDROID_WEBVIEW() {
    return AUTH0_APP_ID_ANDROID_WEBVIEW;
  }

  static get AUTH0_APP_ID_M2M() {
    return AUTH0_APP_ID_M2M;
  }

  static get AUTH0_APP_ID_PARTNERS_WEBAPP() {
    return AUTH0_APP_ID_PARTNERS_WEBAPP;
  }

  static get AUTH_COOKIE() {
    return AUTH_COOKIE;
  }

  static get FAKE_USERNAME_EMAIL_LOCAL_PART() {
    return FAKE_USERNAME_EMAIL_LOCAL_PART;
  }

  static get ILLEGAL_EMAIL_ADDRESS_CHAR_MAPPING() {
    return ILLEGAL_EMAIL_ADDRESS_CHAR_MAPPING;
  }

  static get AUTH0_REMEMBER_ME_DEVICE_ID_KEY() {
    return AUTH0_REMEMBER_ME_DEVICE_ID_KEY;
  }

  static get AUTH0_CLIENT_REMEMBER_ME_DEVICE_ID_OVERRIDE_KEY() {
    return AUTH0_CLIENT_REMEMBER_ME_DEVICE_ID_OVERRIDE_KEY;
  }

  static get AUTH0_REMEMBER_ME_NUM_DAYS() {
    return AUTH0_REMEMBER_ME_NUM_DAYS;
  }

  static get EXTERNAL_APP_ID_SHIPSTATION_CONNECT() {
    return EXTERNAL_APP_ID_SHIPSTATION_CONNECT;
  }

  static get AUTH0_DEV_LOCAL_MULTI_PARTITION_TESTING_KEY() {
    return AUTH0_DEV_LOCAL_MULTI_PARTITION_TESTING_KEY;
  }

  // SessionStorage keys for redirect-based SSO linking flow
  static get AUTH0_LINKING_CACHED_SSO_JWT() {
    return AUTH0_LINKING_CACHED_SSO_JWT;
  }

  static get AUTH0_LINKING_CACHED_SSO_ID_TOKEN() {
    return AUTH0_LINKING_CACHED_SSO_ID_TOKEN;
  }

  static get AUTH0_LINKING_CACHED_SSO_USER_ID() {
    return AUTH0_LINKING_CACHED_SSO_USER_ID;
  }

  static get AUTH0_LINKING_CACHED_METADATA() {
    return AUTH0_LINKING_CACHED_METADATA;
  }
}

export default Auth0Constants;
